import { useState } from 'react';

import { Avatar, AvatarImage } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

export const ThumbnailAvatar = ({ thumbnail, title, href, className = '' }) => {
	const [open, setOpen] = useState(false);

	// Methods
	const onHover = value => setOpen(value);

	// Theme
	const rootClassName = cn('shrink-0 h-auto p-0', className);

	// Render
	return (
		<Link variant='ghost' href={href} className={rootClassName}>
			<Avatar className='shrink-0'>
				<AvatarImage size='xs' src={thumbnail} alt={title} />
			</Avatar>
		</Link>
	);
};
